/** Client-side EAN-13 validation mirroring the backend check-digit algorithm. */
export function ean13CheckDigit(payload12: string): number {
	let sum = 0;
	for (let i = 0; i < 12; i++) {
		const d = payload12.charCodeAt(i) - 48;
		sum += d * (i % 2 === 0 ? 1 : 3);
	}
	return (10 - (sum % 10)) % 10;
}

export function isValidEan13(code: string): boolean {
	if (!/^\d{13}$/.test(code)) return false;
	return ean13CheckDigit(code.slice(0, 12)) === code.charCodeAt(12) - 48;
}

/**
 * Returns an i18n error key for a manually-entered barcode, or "" when acceptable.
 * Custom alphanumeric codes are allowed; a 13-digit numeric code must be a valid EAN-13.
 */
export function barcodeFieldError(code: string): string {
	const c = code.trim();
	if (!c) return "";
	if (/^\d{13}$/.test(c) && !isValidEan13(c)) return "products.errors.invalidBarcode";
	return "";
}
